import React, { useState } from "react";
import axios from "axios";
import "./PaymentEntry.css";
import "./Pjc_dashboard.css";
import { FaBars, FaTimes, FaClipboardCheck, FaUsers, FaFileInvoiceDollar, FaMoneyBillWave } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const COUNTRY_CODES = [
  { code: "+91", country: "India" },
  { code: "+1", country: "USA/Canada" },
  { code: "+44", country: "UK" },
  { code: "+61", country: "Australia" },
  { code: "+971", country: "UAE" },
  { code: "+65", country: "Singapore" },
  { code: "+60", country: "Malaysia" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+974", country: "Qatar" },
  { code: "+968", country: "Oman" },
  { code: "+973", country: "Bahrain" },
  { code: "+965", country: "Kuwait" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+81", country: "Japan" },
  { code: "+86", country: "China" },
  { code: "+27", country: "South Africa" },
  { code: "+64", country: "New Zealand" },
  { code: "+92", country: "Pakistan" },
  { code: "+880", country: "Bangladesh" },
  { code: "+94", country: "Sri Lanka" },
  { code: "+977", country: "Nepal" },
];

const PaymentEntry = () => {
  const initialForm = {
    fullname: "",
    batch: "",
    branch: "",
    country_code: "+91",
    mobile: "",
    email: "",
    aadhaar_no: "",
    pan_no: "",
    fund_type: "",
    contact_person: "",
    contact_person_email: "",
    amount_paid: "",
    payment_date: "",
    payment_mode: "",
    bank_name: "",
    transaction_reference: "",
    remarks: "",
  };
const navigate = useNavigate();

const [mobileOpen, setMobileOpen] = useState(false);
const [sidebarCollapsed] = useState(false);

const [activeItem, setActiveItem] = useState("Alumni Payment Entry");
  const [formData, setFormData] = useState(initialForm);
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  React.useEffect(() => {
    let isMounted = true;
    axios
      .get("/backend/admin/login_verification")
      .then((res) => {
        if (isMounted && res.data && res.data.token_status === "okay") {
          setCurrentUser(res.data.user || null);
        }
      })
      .catch((err) => {
        console.warn("Failed to fetch admin user session:", err);
      });
    return () => {
      isMounted = false;
    };
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post("/backend/admin/logout");
    } catch (err) {
      console.warn("Server logout notification failed:", err);
    }
    navigate("/alumni-login", { replace: true, state: { loggedOut: true } });
  };

  const [notification, setNotification] = useState({
    show: false,
    type: "",
    message: "",
  });
 const currentYear = new Date().getFullYear();

const batchOptions = Array.from(
  { length: currentYear - 1956 + 1 },
  (_, index) => currentYear - index
);

 const handleChange = (e) => {
  const { name, value } = e.target;

  let newValue = value;

  switch (name) {
    case "fullname":
    case "branch":
    case "contact_person":
      newValue = value.replace(/[^A-Za-z ]/g, "");
      break;

    case "mobile":
      newValue = value.replace(/\D/g, "").slice(0, 15);
      break;

    case "batch":
      newValue = value.replace(/\D/g, "").slice(0, 4);
      break;

    case "aadhaar_no":
      newValue = value.replace(/\D/g, "").slice(0, 12);
      break;

    case "pan_no":
      newValue = value
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, 10);
      break;

    case "amount_paid":
      newValue = value.replace(/[^\d.]/g, "");
      break;

    default:
      break;
  }

  setFormData((prev) => ({
    ...prev,
    [name]: newValue,
  }));
};

  const resetForm = () => {
    setFormData(initialForm);
  };

  const closeNotification = () => {
    setNotification({
      show: false,
      type: "",
      message: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
   
if (!/^[A-Za-z ]+$/.test(formData.fullname.trim())) {
  return setNotification({
    show: true,
    type: "error",
    message: "Full Name should contain only letters.",
  });
}


if (
  formData.batch &&
  !/^\d{4}$/.test(formData.batch)
) {
  return setNotification({
    show: true,
    type: "error",
    message: "Batch should be a valid 4-digit year.",
  });
}


if (
  formData.branch &&
  !/^[A-Za-z ]+$/.test(formData.branch.trim())
) {
  return setNotification({
    show: true,
    type: "error",
    message: "Branch should contain only letters.",
  });
}


if (
  formData.mobile &&
  !/^\d{4,15}$/.test(formData.mobile)
) {
  return setNotification({
    show: true,
    type: "error",
    message: "Enter a valid mobile number.",
  });
}


if (
  !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
) {
  return setNotification({
    show: true,
    type: "error",
    message: "Invalid email address.",
  });
}


if (
  formData.aadhaar_no &&
  !/^\d{12}$/.test(formData.aadhaar_no)
) {
  return setNotification({
    show: true,
    type: "error",
    message: "Aadhaar number must contain 12 digits.",
  });
}


if (
  formData.pan_no &&
  !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.pan_no)
) {
  return setNotification({
    show: true,
    type: "error",
    message: "Invalid PAN Number.",
  });
}


if (formData.fund_type === "CSR") {

  if (
    formData.contact_person &&
    !/^[A-Za-z ]+$/.test(formData.contact_person.trim())
  ) {
    return setNotification({
      show: true,
      type: "error",
      message: "Contact Person should contain only letters.",
    });
  }

  if (
    formData.contact_person_email &&
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.contact_person_email)
  ) {
    return setNotification({
      show: true,
      type: "error",
      message: "Invalid Contact Person Email.",
    });
  }
}


if (
  Number(formData.amount_paid) <= 0
) {
  return setNotification({
    show: true,
    type: "error",
    message: "Amount must be greater than 0.",
  });
}


if (!formData.bank_name.trim()) {
  return setNotification({
    show: true,
    type: "error",
    message: "Bank Name is required.",
  });
}


if (!formData.transaction_reference.trim()) {
  return setNotification({
    show: true,
    type: "error",
    message: "Transaction Reference is required.",
  });
}

    setLoading(true);

    try {
      const res = await axios.post(
        "/backend/admin/payment-entry",
        formData
      );

      setNotification({
        show: true,
        type: "success",
        message:"Payment submitted successfully.",
      });

      resetForm();
    } catch (err) {
      console.error("Payment Entry Error:", err);

  
  console.error("Server Response:", err.response?.data);
      setNotification({
        show: true,
        type: "error",
        message:"Unable to submit payment.",
      });
    } finally {
      setLoading(false);
    }
  };
const ADMIN_NAVIGATION = [
  { label: "Pending Approvals", icon: FaClipboardCheck },
  { label: "All Transactions", icon: FaFileInvoiceDollar },
  { label: "Alumni / Users", icon: FaUsers },
  // { label: "Payment Plans", icon: FaFileInvoiceDollar },
   { label: "Alumni Payment Entry", icon: FaMoneyBillWave },
];
  return (
    <div className="payment-page">
      {mobileOpen && (
              <button
                className="pjc-sidebar-backdrop"
                onClick={() => setMobileOpen(false)}
                aria-label="Close navigation sidebar"
              />
            )}
      
            {/* Redesigned Sidebar Navigation */}
            <aside className={`pjc-sidebar ${sidebarCollapsed ? "is-collapsed" : ""} ${mobileOpen ? "is-open" : ""}`}>
              <div className="pjc-brand">
                <div className="pjc-brand-mark">P</div>
                <div className="pjc-brand-text">
                  <span>PJC Fund</span>
                  <small>Admin View</small>
                </div>
                <button className="pjc-close-sidebar" onClick={() => setMobileOpen(false)} aria-label="Close navigation">
                  <FaTimes />
                </button>
              </div>
      
              <p className="pjc-sidebar-label">MANAGEMENT</p>
              <nav className="pjc-nav" aria-label="Dashboard navigation">
                {ADMIN_NAVIGATION.map(({ label, icon: Icon }) => (
                  <button
                    key={label}
                    className={`pjc-nav-link ${activeItem === label ? "active" : ""}`}
                    onClick={() => {
          if (label === "Alumni Payment Entry") {
              navigate("/payment-entry");
          } else {
              navigate("/admin-dashboard", {
      state: { activeItem: label }
    });
          }
      
          setMobileOpen(false);
      }}
                    title={label}
                  >
                    <Icon aria-hidden="true" />
                    <span>{label}</span>
                  </button>
                ))}
              </nav>
      
              {/* <button
                className="pjc-collapse-button"
                onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
                aria-label="Toggle sidebar width"
              >
                {sidebarCollapsed ? <FaChevronRight /> : <FaChevronLeft />}
                <span>Collapse Sidebar</span>
              </button> */}
            </aside>
            
        

      {notification.show && (
        <div className="notification-overlay">
          <div
            className={`notification-card ${
              notification.type === "success"
                ? "success"
                : "error"
            }`}
          >
            

            {notification.type === "success" && (
  <h3>Success</h3>
)}

<p>{notification.message}</p>

           

            <button
              type="button"
              className="notification-btn"
              onClick={closeNotification}
            >
              OK
            </button>
          </div>
        </div>
      )}
      <header className="pjc-topbar payment-topbar">
        <div className="pjc-topbar-title-group">
          <button
            className="pjc-menu-button"
            onClick={() => setMobileOpen(true)}
            aria-label="Open sidebar menu"
          >
            <FaBars />
          </button>
          <div>
            <h1>Welcome, {currentUser?.username || currentUser?.fullname || "Admin"}</h1>
          </div>
        </div>
        <div className="pjc-topbar-actions">
          <button 
            className="pjc-logout-btn" 
            onClick={handleLogout} 
            title="Logout of session"
          >
            Logout
          </button>
        </div>
      </header>

      <div className="payment-card">

        <div className="payment-header">
          <h2>Payment Entry Form</h2>
          <p>Alumni Contribution Details</p>
        </div>

        <form onSubmit={handleSubmit}>

         <div className="payment-grid">

  <div className="payment-group">
    <label>Full Name <span>*</span></label>
    <input
      type="text"
      name="fullname"
      value={formData.fullname}
      onChange={handleChange}
      placeholder="Enter name"
      required
    />
  </div>


  <div className="payment-group">
  <label>Branch <span>*</span></label>
  <select
    name="branch"
    value={formData.branch}
    onChange={handleChange}
     required
  >
    <option value="">Select Branch</option>
    <option value="CSE">CSE</option>
    <option value="MECH">MECH</option>
    <option value="CIVIL">CIVIL</option>
    <option value="ECE">ECE</option>
    <option value="EEE">EEE</option>
    <option value="MCA">MCA</option>
    <option value="OTHERS">OTHERS</option>
  </select>
</div>

   <div className="payment-group">
  <label>Batch</label>
  <select
    name="batch"
    value={formData.batch}
    onChange={handleChange}
  >
    <option value="">Select Batch</option>

    {batchOptions.map((year) => (
      <option key={year} value={year}>
        {year}
      </option>
    ))}
  </select>
</div>


  <div className="payment-group">
    <label>Mobile</label>
    <div className="payment-mobile-group">
      <select
        name="country_code"
        value={formData.country_code}
        onChange={handleChange}
      >
        {COUNTRY_CODES.map(({ code, country }) => (
          <option key={code} value={code}>
            {code} ({country})
          </option>
        ))}
      </select>
      <input
        type="text"
        name="mobile"
        value={formData.mobile}
        onChange={handleChange}
        placeholder="Enter Mobile number"
      />
    </div>
  </div>

  <div className="payment-group">
    <label>Email <span>*</span></label>
    <input
      type="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      placeholder="Enter Email id"
      required
    />
  </div>

  <div className="payment-group">
    <label>Aadhaar Number</label>
    <input
      type="text"
      name="aadhaar_no"
      maxLength="12"
      value={formData.aadhaar_no}
      onChange={handleChange}
      placeholder="Enter Aadhaar no"
    />
  </div>

  <div className="payment-group">
    <label>PAN Number</label>
    <input
      type="text"
      name="pan_no"
      maxLength="10"
      value={formData.pan_no}
      onChange={handleChange}
      placeholder="Enter Pan No"
    />
  </div>

  <div className="payment-group">
    <label>Fund Type <span>*</span></label>
    <select
      name="fund_type"
      value={formData.fund_type}
      onChange={handleChange}
      required
    >
      <option value="">Select Fund Type</option>
      <option value="OWN">OWN</option>
      <option value="CSR">CSR</option>
    </select>
  </div>

  {formData.fund_type === "CSR" && (
    <>
      <div className="payment-group">
        <label>Contact Person</label>
        <input
          type="text"
          name="contact_person"
          value={formData.contact_person}
          onChange={handleChange}
          placeholder="Enter Contact Person Name"
       
        />
      </div>

      <div className="payment-group">
        <label>Contact Person Email </label>
        <input
          type="email"
          name="contact_person_email"
          value={formData.contact_person_email}
          onChange={handleChange}
          placeholder="Enter Contact Person Email Id"
         
        />
      </div>
    </>
  )}

  <div className="payment-group">
    <label>Amount Paid <span>*</span></label>
    <input
      type="text"
      name="amount_paid"
      value={formData.amount_paid}
      onChange={handleChange}
      placeholder="Enter Amount"
      required
    />
  </div>

  <div className="payment-group">
    <label>Payment Date <span>*</span></label>
    <input
      type="date"
      name="payment_date"
      value={formData.payment_date}
      onChange={handleChange}
      required
      min="2026-04-01"
    />
  </div>

  <div className="payment-group">
    <label>Payment Mode <span>*</span></label>
    <select
      name="payment_mode"
      value={formData.payment_mode}
      onChange={handleChange}
      required
    >
      <option value="">Select Payment Mode</option>
      <option value="UPI">UPI</option>
      <option value="Net Banking">Net Banking</option>
      <option value="NEFT">NEFT</option>
      <option value="RTGS">RTGS</option>
      <option value="Cash">Cash</option>
      <option value="Cheque">Cheque</option>
    </select>
  </div>

  <div className="payment-group">
    <label>Bank Name <span>*</span></label>
    <input
      type="text"
      name="bank_name"
      value={formData.bank_name}
      onChange={handleChange}
      placeholder="State Bank of India"
      required
    />
  </div>

  <div className="payment-group">
    <label>Transaction Reference <span>*</span></label>
    <input
      type="text"
      name="transaction_reference"
      value={formData.transaction_reference}
      onChange={handleChange}
      placeholder="UTR / Transaction ID"
      required
    />
  </div>

</div>

<div className="payment-group payment-full">
  <label>Remarks</label>
  <textarea
    rows="4"
    name="remarks"
    value={formData.remarks}
    onChange={handleChange}
    placeholder="Enter Remarks"
  />
</div>

<div className="payment-btn-div">
  <button
    type="submit"
    className="payment-submit-btn"
    disabled={loading}
  >
    {loading ? "Submitting..." : "Submit "}
  </button>
</div>

        </form>

      </div>

    </div>
  );
};

export default PaymentEntry;